export enum EProductGroupType {
    BANNER_SQ_FT = 'BANNER_SQ_FT',
    VINYL_SQ_FT = 'VINYL_SQ_FT',
    SPECIAL_MEDIA_SQ_FT = 'SPECIAL_MEDIA_SQ_FT',
    SHEET_BOARD_SQ_FT_OR_SQ_INCH = 'SHEET_BOARD_SQ_FT_OR_SQ_INCH',
    DISPLAY_ITEM_PCS = 'DISPLAY_ITEM_PCS',
}
